import { ScheduleType } from '@core/referential/schedule-type.enum'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { familyOfTab, FamilySchema } from '..'

export const SearchSchema = z
  .object({
    defaultType: z.union([z.nativeEnum(ScheduleType), z.literal('cta'), z.literal('vrv'), z.literal('heatedFloor')]).default(ScheduleType.HEATING),
    // When set alongside defaultType='vrv' or 'heatedFloor', the comfort calendar wizard opens in edit mode for this group.
    comfortGroupId: z.string().uuid().optional(),
    // Entrée de sidebar dont dépend cette page. Déduite de l'onglet visé quand elle n'est pas fournie :
    // le routeur réinjecte le résultat validé dans l'URL, ce qui suffit à garder « Calendrier » surligné.
    family: FamilySchema.optional(),
  })
  .transform((search) => ({ ...search, family: search.family ?? familyOfTab(search.defaultType) }))

export type Search = z.infer<typeof SearchSchema>

export const Route = createFileRoute('/_dashboard/site/$id/operation/scheduler/create/')({
  validateSearch: SearchSchema,
})
